import { Generic as ProductFields } from 'defs/ga/fields/product';

export const Fields = {
	Favorite: 'favorite',
	ButtonText: 'buttonText',
	ProductName: ProductFields.ProductName,
	ProductId: ProductFields.ProductId,
	Type: 'coachCardType',
};
